// Hero 数据
export const heroData = {
  tag: "🔥 每日实时更新中",
  title: "51吃瓜网站 — 你的深度吃瓜第一站",
  slogan: "聚焦每日大赛 · 台北娜娜 · 莫里秀 · 玩偶姐姐，不错过每一个热点",
  intro: "51吃瓜网站是国内领先的特色栏目专区，专注整合每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列的深度内容。我们每日追踪全网最新动态，提供高清视频合集与优质资源，以最快的更新速度和最全面的内容覆盖，为吃瓜爱好者打造一站式的浏览体验。当前站点已收录海量专题内容，涵盖热门话题追踪、精品合集推荐、实时快讯更新等板块，让你轻松掌握每一个值得关注的精彩瞬间。",
  stats: [
    { value: "50+", label: "每日内容更新" },
    { value: "100+", label: "热门话题覆盖" },
    { value: "高清", label: "画质 安全浏览" },
  ],
  primaryCta: { text: "立即浏览热门", href: "#topics" },
  secondaryCta: { text: "探索特色栏目", href: "#cards" },
};

// #about 数据 - 1项
export const aboutData = {
  title: "关于51吃瓜",
  description: "51吃瓜网站诞生于对网络热点内容的深度热爱。我们坚信，每一份精彩的吃瓜内容都值得被记录、被整理、被分享。作为专业的特色栏目平台，我们汇聚了每日大赛的精彩对决、台北娜娜的独家合集、莫里秀系列的全网追踪以及玩偶姐姐的高清资源。我们以稳定、高速、安全的浏览体验为基础，持续追踪黑料吃瓜的最新进展，确保每一位用户都能在这里找到自己想要的内容。从视频合集到实时快讯，从热门话题到深度评论，51吃瓜网站致力于成为你最信赖的吃瓜伙伴。",
};

// #carousel 数据 - 4项（静态展示，全部可见）
export const carouselItems = [
  {
    id: "daily-contest",
    title: "每日大赛",
    subtitle: "精彩对决 日日更新",
    description: "追踪每日最火爆的大赛对决，实时更新赛场动态与高光时刻，为你呈现最全面的赛事内容合集。",
    tag: "热门系列",
    image: "https://readdy.ai/api/search-image?query=dramatic%20entertainment%20stage%20with%20spotlights%20and%20dynamic%20atmosphere%2C%20warm%20golden%20and%20red%20tones%2C%20theatrical%20lighting%2C%20grand%20performance%20venue%2C%20cinematic%20composition%2C%20high%20contrast%2C%20professional%20photography%20style%20with%20soft%20bokeh%20background%2C%20artistic%20rendering%20of%20stage%20lights&width=800&height=500&seq=carousel-daily-001&orientation=landscape",
  },
  {
    id: "taipei-nana",
    title: "台北娜娜",
    subtitle: "独家合集 持续追踪",
    description: "台北娜娜系列全内容追踪，从最新视频到经典合集，一站式满足你对娜娜系列的所有期待。",
    tag: "人气之选",
    image: "https://readdy.ai/api/search-image?query=urban%20cityscape%20at%20twilight%20with%20warm%20ambient%20lighting%2C%20modern%20fashionable%20atmosphere%2C%20elegant%20city%20night%20scene%2C%20soft%20neon%20accents%20against%20dark%20sky%2C%20contemporary%20aesthetic%2C%20cinematic%20mood%2C%20professional%20photography%20with%20shallow%20depth%20of%20field&width=800&height=500&seq=carousel-nana-002&orientation=landscape",
  },
  {
    id: "mori-show",
    title: "莫里秀",
    subtitle: "全网追踪 深度解读",
    description: "莫里秀系列全网最全收录，深度追踪每期内容的来龙去脉，带你了解事件背后的故事。",
    tag: "深度追踪",
    image: "https://readdy.ai/api/search-image?query=fashion%20runway%20show%20with%20dramatic%20lighting%20and%20elegant%20atmosphere%2C%20warm%20spotlight%20illuminating%20center%20stage%2C%20sophisticated%20venue%20interior%2C%20golden%20and%20amber%20color%20palette%2C%20theatrical%20ambiance%2C%20artistic%20photography%20with%20lens%20flare%20effects&width=800&height=500&seq=carousel-mori-003&orientation=landscape",
  },
  {
    id: "doll-sister",
    title: "玩偶姐姐",
    subtitle: "高清资源 精品合集",
    description: "玩偶姐姐全系列高清视频合集，持续更新最新内容，为你提供最完整的观看体验与资源整理。",
    tag: "精品推荐",
    image: "https://readdy.ai/api/search-image?query=artistic%20studio%20photography%20scene%20with%20soft%20pastel%20lighting%2C%20elegant%20composition%2C%20minimal%20aesthetic%20with%20warm%20cream%20and%20rose%20tones%2C%20dreamy%20atmosphere%2C%20fine%20art%20photography%20style%2C%20gentle%20shadows%20creating%20depth%2C%20professional%20set%20design&width=800&height=500&seq=carousel-doll-004&orientation=landscape",
  },
];

// #app 数据 - 1项
export const appEntry = {
  title: "随时随地 轻松吃瓜",
  description: "51吃瓜网站全面适配移动端浏览，无需下载安装，打开浏览器即可畅享全部内容。高清视频合集、实时快讯更新、热门话题追踪，随时随地掌握最新吃瓜动态。无论是通勤路上还是闲暇时光，51吃瓜陪你轻松逛遍每一个精彩专题。",
};

// #topics 数据 - 10项
export const topicTags = [
  { name: "每日大赛", heat: "🔥 999+", description: "赛事追踪与精彩对决实时更新" },
  { name: "台北娜娜", heat: "🔥 888+", description: "独家视频合集持续追踪" },
  { name: "莫里秀", heat: "🔥 777+", description: "全网深度解读与事件还原" },
  { name: "玩偶姐姐", heat: "🔥 666+", description: "高清资源与精品合集推荐" },
  { name: "黑料吃瓜", heat: "🔥 555+", description: "最新爆料与独家揭秘" },
  { name: "视频合集", heat: "🔥 444+", description: "优质内容一站式整理" },
  { name: "实时快讯", heat: "🔥 333+", description: "热点新闻第一时间送达" },
  { name: "深度评论", heat: "🔥 222+", description: "专业视角解读热门事件" },
  { name: "热门榜单", heat: "🔥 188+", description: "每周人气排行与趋势分析" },
  { name: "资源推荐", heat: "🔥 166+", description: "编辑精选优质内容推送" },
];

// #index 数据 - 9项
export const indexItems = [
  { title: "每日大赛 · 本周精选", count: "36期", description: "本周最热门大赛对决全收录" },
  { title: "台北娜娜 · 最新合集", count: "24期", description: "娜娜系列最新更新一次看够" },
  { title: "莫里秀 · 事件全纪录", count: "18期", description: "从起因到结局的完整追踪" },
  { title: "玩偶姐姐 · 高清专区", count: "42期", description: "最高画质体验，畅享视觉盛宴" },
  { title: "黑料吃瓜 · 独家揭秘", count: "15期", description: "最新爆料内容一网打尽" },
  { title: "视频合集 · 编辑推荐", count: "28期", description: "精选优质视频打包放送" },
  { title: "热门话题 · 月度回顾", count: "12期", description: "当月最火爆话题全记录" },
  { title: "特色栏目 · 专题策划", count: "20期", description: "编辑团队精心策划的深度专题" },
  { title: "资源更新 · 最新入库", count: "55期", description: "最新入库内容速览与导航" },
];

// #comments 数据 - 4项
export const commentItems = [
  { avatar: "匿", name: "吃瓜群众A", time: "2小时前", content: "终于找到一个把每日大赛整理得这么清楚的网站了！台北娜娜的合集也很全，每天都要上来刷一遍，更新速度真的快。" },
  { avatar: "名", name: "热心网友B", time: "5小时前", content: "莫里秀的深度追踪做得太好了，每期事件来龙去脉都很清楚，比在其他地方东拼西凑找资料方便太多了，已推荐给朋友。" },
  { avatar: "瓜", name: "资深吃瓜C", time: "1天前", content: "玩偶姐姐的高清专区画质真的绝，而且更新很及时。最重要的是浏览体验很流畅，没有乱七八糟的广告，这个必须点赞。" },
  { avatar: "粉", name: "路人转粉D", time: "2天前", content: "之前一直在找靠谱的吃瓜资源站，试了好几个都不满意。51吃瓜的内容质量和更新速度真的没话说，黑料吃瓜板块也很精彩。" },
];

// #cards 数据 - 5项
export const cardItems = [
  {
    title: "每日大赛 · 精彩对决",
    description: "每日追踪最火大赛动态，实时更新对决结果与高光时刻，让你不错过任何精彩瞬间。",
    tag: "热门追踪",
    image: "https://readdy.ai/api/search-image?query=dramatic%20competition%20stage%20with%20golden%20lighting%2C%20two%20silhouettes%20facing%20each%20other%20in%20a%20grand%20arena%2C%20warm%20amber%20atmosphere%2C%20theatrical%20spotlight%2C%20cinematic%20composition%2C%20professional%20photography%20style&width=600&height=400&seq=card-daily-001&orientation=landscape",
  },
  {
    title: "台北娜娜 · 独家追踪",
    description: "娜娜系列最全合集，从最新内容到经典回顾，持续更新，一站式满足你的追更需求。",
    tag: "人气合集",
    image: "https://readdy.ai/api/search-image?query=elegant%20urban%20night%20scene%20with%20soft%20city%20lights%20reflecting%20on%20glass%20windows%2C%20modern%20architecture%2C%20warm%20golden%20and%20rose%20tones%2C%20sophisticated%20mood%2C%20cinematic%20photography%20with%20shallow%20depth%20of%20field&width=600&height=400&seq=card-nana-002&orientation=landscape",
  },
  {
    title: "莫里秀 · 深度解读",
    description: "事件全纪录，从起因经过到结局完整追踪。专业视角为你还原最真实的来龙去脉。",
    tag: "深度内容",
    image: "https://readdy.ai/api/search-image?query=fashion%20show%20backstage%20atmosphere%20with%20warm%20lighting%2C%20elegant%20fabric%20textures%2C%20professional%20photography%20setup%2C%20golden%20hour%20ambient%20light%2C%20artistic%20composition%2C%20sophisticated%20interior%20design%20elements&width=600&height=400&seq=card-mori-003&orientation=landscape",
  },
  {
    title: "玩偶姐姐 · 精品专区",
    description: "全系列高清视频合集，精品画质体验，持续更新最新内容，给你最好的观看享受。",
    tag: "精品推荐",
    image: "https://readdy.ai/api/search-image?query=artistic%20still%20life%20photography%20with%20elegant%20composition%2C%20soft%20natural%20light%20from%20window%2C%20warm%20cream%20and%20beige%20tones%2C%20minimal%20aesthetic%2C%20fine%20art%20quality%2C%20delicate%20textures%2C%20professional%20studio%20atmosphere&width=600&height=400&seq=card-doll-004&orientation=landscape",
  },
  {
    title: "黑料吃瓜 · 独家揭秘",
    description: "最新爆料内容一网打尽，独家视角呈现事件背后的故事。持续追踪黑料吃瓜的最新进展。",
    tag: "独家内容",
    image: "https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20concept%20with%20warm%20dramatic%20lighting%2C%20artistic%20representation%20of%20revelation%2C%20rich%20amber%20and%20gold%20tones%2C%20mysterious%20atmosphere%2C%20professional%20photography%20style%2C%20high%20contrast%20composition&width=600&height=400&seq=card-heiliao-005&orientation=landscape",
  },
];

// #contact 数据 - 1项
export const contactData = {
  title: "联系我们",
  description: "如果你有精彩的内容线索、想要投稿分享，或者有合作意向，欢迎通过以下方式与我们取得联系。51吃瓜网站期待与你一起打造更优质的吃瓜内容生态。",
  email: "contact@51chigua.example.com",
  tips: ["内容投稿", "商务合作", "意见建议", "问题反馈"],
};

// #ranking 数据 - 7项
export const rankingItems = [
  { rank: 1, title: "本周每日大赛巅峰对决合集", heat: "热度 999+", tag: "每日大赛" },
  { rank: 2, title: "台北娜娜最新系列完整追踪", heat: "热度 888+", tag: "台北娜娜" },
  { rank: 3, title: "莫里秀事件终极全纪录", heat: "热度 777+", tag: "莫里秀" },
  { rank: 4, title: "玩偶姐姐高清合集大放送", heat: "热度 666+", tag: "玩偶姐姐" },
  { rank: 5, title: "黑料吃瓜最新独家揭秘系列", heat: "热度 555+", tag: "黑料吃瓜" },
  { rank: 6, title: "本月最火视频合集精选推荐", heat: "热度 444+", tag: "视频合集" },
  { rank: 7, title: "全网热门话题一周回顾", heat: "热度 333+", tag: "热门话题" },
];

// #updates 数据 - 8项
export const updateItems = [
  {
    time: "2026-07-29 14:30",
    title: "每日大赛本周巅峰对决更新",
    summary: "本周每日大赛迎来新一轮精彩对决，多个热门选手激烈交锋，完整视频合集已同步上线。",
    tag: "每日大赛",
  },
  {
    time: "2026-07-29 10:15",
    title: "台北娜娜最新视频合集发布",
    summary: "娜娜系列最新内容已整理上线，包含近期更新的全部视频资源，画质高清，欢迎浏览。",
    tag: "台北娜娜",
  },
  {
    time: "2026-07-28 20:45",
    title: "莫里秀深度追踪特别篇上线",
    summary: "针对近期热门事件，编辑团队整理了一份完整的莫里秀事件时间线，从起因到最新进展一应俱全。",
    tag: "莫里秀",
  },
  {
    time: "2026-07-28 16:00",
    title: "玩偶姐姐精品合集更新通知",
    summary: "玩偶姐姐专区新入库多部高清视频，画质全面提升，推荐使用大屏设备获得最佳观看体验。",
    tag: "玩偶姐姐",
  },
  {
    time: "2026-07-27 11:20",
    title: "黑料吃瓜板块新增独家内容",
    summary: "最新爆料内容已整理完毕，多角度还原事件真相，持续追踪黑料吃瓜的最新动态。",
    tag: "黑料吃瓜",
  },
  {
    time: "2026-07-27 08:00",
    title: "热门话题月度回顾视频上线",
    summary: "本月热门话题回顾视频已制作完成，精选当月最具讨论度的内容，方便错过热点的用户补课。",
    tag: "热门话题",
  },
  {
    time: "2026-07-26 15:30",
    title: "视频合集专区新增编辑推荐",
    summary: "编辑团队从近期入库内容中精选出优质视频，整理成合集推荐，涵盖多个热门系列。",
    tag: "视频合集",
  },
  {
    time: "2026-07-26 09:00",
    title: "站点资源更新周报发布",
    summary: "本周新增海量内容入库，覆盖每日大赛、台北娜娜、莫里秀、玩偶姐姐等全系列，欢迎查阅。",
    tag: "资源更新",
  },
];

// #faq 数据 - 4项
export const faqItems = [
  {
    question: "51吃瓜网站提供哪些内容？",
    answer: "51吃瓜网站是一个特色栏目专区平台，聚焦每日大赛最新动态、台北娜娜视频合集、莫里秀深度追踪以及玩偶姐姐高清资源。同时覆盖黑料吃瓜、热门话题、视频合集等多个板块，为用户提供一站式的吃瓜内容服务。所有内容均为整理聚合性质，方便用户快速浏览和查找感兴趣的热门系列。",
  },
  {
    question: "网站内容多久更新一次？",
    answer: "我们的编辑团队保持每日高频更新，每日大赛板块实时追踪最新动态，各系列视频合集根据内容发布节奏及时同步整理。快讯模块基本做到当天热点当天上线，确保用户能够第一时间获取最新吃瓜内容。建议将站点加入收藏夹，方便随时访问。",
  },
  {
    question: "如何使用特色栏目快速找到想看的内容？",
    answer: "首页提供了多种浏览方式：通过顶部导航可以快速跳转到最新快讯、精选视频、热门话题、特色栏目等核心板块；通过话题标签区域可以按主题筛选感兴趣的内容；热度榜单则展示了当前最受欢迎的内容排行。此外，索引专区提供了完整的专题合集导航，帮助你全面了解站点内容覆盖范围。",
  },
  {
    question: "网站支持移动端浏览吗？",
    answer: "当然支持！51吃瓜网站全面适配手机和平板等移动设备，无需下载安装任何APP，直接通过浏览器访问即可获得流畅的浏览体验。页面布局会根据屏幕尺寸自动适配，无论是通勤路上还是在家休息，都能随时随地轻松吃瓜。",
  },
];

// #media 数据 - 4项（外观展示，无真实播放）
export const mediaItems = [
  {
    title: "每日大赛 · 本周巅峰对决集锦",
    duration: "15:42",
    views: "12.8万",
    tag: "每日大赛",
    image: "https://readdy.ai/api/search-image?query=dramatic%20arena%20stage%20with%20golden%20spotlight%20and%20dynamic%20atmosphere%2C%20two%20figures%20in%20competition%20pose%2C%20warm%20amber%20lighting%2C%20cinematic%20wide%20shot%2C%20professional%20broadcast%20quality&width=640&height=360&seq=media-daily-001&orientation=landscape",
  },
  {
    title: "台北娜娜 · 最新系列完整回顾",
    duration: "22:15",
    views: "9.6万",
    tag: "台北娜娜",
    image: "https://readdy.ai/api/search-image?query=modern%20urban%20landscape%20at%20sunset%20with%20warm%20golden%20light%2C%20city%20skyline%20silhouette%2C%20elegant%20atmosphere%2C%20cinematic%20composition%20with%20soft%20gradients%2C%20professional%20photography&width=640&height=360&seq=media-nana-002&orientation=landscape",
  },
  {
    title: "莫里秀 · 事件全纪录深度解读",
    duration: "18:30",
    views: "8.3万",
    tag: "莫里秀",
    image: "https://readdy.ai/api/search-image?query=fashion%20runway%20stage%20with%20dramatic%20theatrical%20lighting%2C%20elegant%20atmosphere%2C%20warm%20amber%20and%20gold%20spotlights%2C%20professional%20show%20production%2C%20cinematic%20wide%20angle%20photography&width=640&height=360&seq=media-mori-003&orientation=landscape",
  },
  {
    title: "玩偶姐姐 · 高清精品合集放送",
    duration: "28:50",
    views: "11.2万",
    tag: "玩偶姐姐",
    image: "https://readdy.ai/api/search-image?query=artistic%20studio%20scene%20with%20soft%20natural%20light%20streaming%20through%20windows%2C%20elegant%20minimal%20setting%2C%20warm%20cream%20and%20beige%20tones%2C%20professional%20photography%20quality%2C%20dreamy%20atmospheric%20mood&width=640&height=360&seq=media-doll-004&orientation=landscape",
  },
];

// #features 数据 - 5项
export const featureItems = [
  {
    icon: "ri-flashlight-line",
    title: "极速更新",
    description: "编辑团队全天候追踪热点，确保每日大赛、台北娜娜等热门系列第一时间同步更新，让你快人一步获取最新动态。",
  },
  {
    icon: "ri-stack-line",
    title: "全面覆盖",
    description: "从每日大赛到玩偶姐姐，从黑料吃瓜到热门话题，全系列内容一网打尽，无需在多个平台间反复切换查找。",
  },
  {
    icon: "ri-hd-line",
    title: "高清画质",
    description: "全部视频合集优先提供高清资源，支持多种设备浏览，为你呈现最优质的视觉体验与沉浸式观看享受。",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全浏览",
    description: "站点严格管理内容来源，杜绝恶意弹窗和诱导链接，保障用户在浏览过程中的信息安全与体验流畅度。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端适配",
    description: "全面适配桌面端和移动端设备，无需安装APP，打开浏览器即可畅享全部内容，随时随地轻松吃瓜。",
  },
];

// 导航配置
export const navConfig = {
  siteName: "51吃瓜",
  navItems: [
    { label: "首页", href: "#hero" },
    { label: "最新快讯", href: "#updates" },
    { label: "精选视频", href: "#media" },
    { label: "热门话题", href: "#topics" },
    { label: "特色栏目", href: "#cards" },
    { label: "平台优势", href: "#features" },
  ],
};

// Footer 数据
export const footerData = {
  description: "51吃瓜网站 — 聚焦每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列，提供最新视频合集与高清资源。特色栏目专区满足深度吃瓜需求，黑料吃瓜实时追踪，做你最信赖的吃瓜内容平台。",
  sections: [
    {
      title: "快速导航",
      links: [
        { label: "最新快讯", href: "#updates" },
        { label: "精选视频", href: "#media" },
        { label: "热门话题", href: "#topics" },
        { label: "特色栏目", href: "#cards" },
        { label: "热度榜单", href: "#ranking" },
      ],
    },
    {
      title: "特色系列",
      links: [
        { label: "每日大赛", href: "#carousel" },
        { label: "台北娜娜", href: "#carousel" },
        { label: "莫里秀", href: "#carousel" },
        { label: "玩偶姐姐", href: "#carousel" },
        { label: "黑料吃瓜", href: "#topics" },
      ],
    },
    {
      title: "帮助中心",
      links: [
        { label: "常见问题", href: "#faq" },
        { label: "联系我们", href: "#contact" },
        { label: "关于我们", href: "#about" },
        { label: "索引导航", href: "#index" },
        { label: "平台优势", href: "#features" },
      ],
    },
  ],
  copyright: "© 2026 51吃瓜网站. All Rights Reserved.",
};